import { ProfessionTypeEnum } from '~/models';

export enum AuthorizationStatus {
  PendingVerification = 'pending_verification',
  Verified = 'verified',
  Invalid = 'invalid',
  Expired = 'expired',
}

export enum CredentialV2TypeEnum {
  Artifact = 'artifact',
  Number = 'number',
  Npi = 'npi',
  Reference = 'reference',
}

export enum CredentialV2Enum {
  StateLicense = 'state_license',
  DACertificate = 'da_certificate',
  Radiology = 'radiology',
  CprBls = 'cpr/bls',
  Reference = 'reference',
  Upload = 'upload',
  Npi = 'npi',
}

export interface ICredentialNumberData {
  readonly number: {
    readonly credentialNumber: string;
  };
}

export interface ICredentialNpiData {
  readonly npi: {
    readonly npiNumber: string;
  };
}

export interface ICredentialReferenceData {
  readonly reference: {
    readonly officeName: string;
    readonly contactEmail: string;
    readonly startDate: string;
    readonly endDate: string;
  };
}

export interface ICredentialArtifactFile {
  readonly id: string;
  readonly url: string;
}

export interface ICredentialArtifactData {
  readonly artifact: {
    readonly files?: ICredentialArtifactFile[];
  };
}

export type CredentialData =
  | ICredentialNumberData
  | ICredentialNpiData
  | ICredentialReferenceData
  | ICredentialArtifactData;

export interface IAuthorizationCredential {
  readonly id: string | null;
  readonly credentialName: string;
  readonly credential: CredentialV2Enum;
  readonly type: CredentialV2TypeEnum;
  readonly status: AuthorizationStatus | null;
  readonly issuedAt: Date | null;
  readonly expiredAt: Date | null;
  readonly expiresSoon: boolean;
  readonly isDraft: boolean;
  readonly isRequired: boolean;
  readonly data: CredentialData | null;
}

export interface IAuthorization {
  readonly id: string;
  readonly professionalId: string;
  readonly profession: ProfessionTypeEnum;
  readonly state: string;
  readonly isAuthorized: boolean;
  readonly status: AuthorizationStatus;
  readonly authorizationExpiresAt: Date | null;
  readonly credentials: IAuthorizationCredential[];
}
